import { createRouter, createWebHistory } from 'vue-router'
import Cookies from 'js-cookie'
import { hostBridge } from '@/utils/hostBridge'

/**
 * 路由配置
 * 对应原 Nuxt pages/ 文件路由
 */
const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes: [
        // ==================== 根路径重定向 ====================
        {
            path: '/',
            redirect: '/model',
        },

        // ==================== 模型列表（「更多」跳转目标）====================
        {
            path: '/model',
            name: 'ModelList',
            component: () => import('@/views/model/index.vue'),
            meta: { title: '数据模型' },
        },
        {
            path: '/model/expert',
            name: 'ModelExpert',
            component: () => import('@/views/model/expert.vue'),
            meta: { title: '专家模型' },
        },
        {
            path: '/model/ai',
            name: 'ModelAI',
            component: () => import('@/views/model/ai.vue'),
            meta: { title: 'AI模型' },
        },
        {
            path: '/ai-home',
            name: 'AiHome',
            component: () => import('@/views/ai-home/index.vue'),
            meta: { title: 'AI首页' },
        },
        {
            path: '/ai-home/today-matches',
            name: 'AiHomeTodayMatches',
            component: () => import('@/views/ai-home/today-matches.vue'),
            meta: { title: '当日比赛' },
        },
        {
            path: '/ai-home/create-plan',
            name: 'AiHomeCreatePlan',
            component: () => import('@/views/ai-home/create-plan.vue'),
            meta: { title: '做个方案' },
        },
        {
            path: '/ai-home/data-analysis',
            name: 'AiHomeDataAnalysis',
            component: () => import('@/views/ai-home/data-analysis.vue'),
            meta: { title: '数据拆解' },
        },
        {
            path: '/ai-home/trend-analysis',
            name: 'AiHomeTrendAnalysis',
            component: () => import('@/views/ai-home/trend-analysis.vue'),
            meta: { title: '趋势推荐' },
        },
        {
            path: '/ai-home/daily-report',
            name: 'AiHomeDailyReport',
            component: () => import('@/views/ai-home/daily-report.vue'),
            meta: { title: '今日深度报告' },
        },
        {
            path: '/ai-home/data-monitor',
            name: 'AiHomeDataMonitor',
            component: () => import('@/views/ai-home/data-monitor.vue'),
            meta: { title: '数据深度监测' },
        },
        {
            path: '/ai-home/hit-rate',
            name: 'AiHomeHitRate',
            component: () => import('@/views/ai-home/hit-rate.vue'),
            meta: { title: '红单命中' },
        },
        {
            path: '/ai-home/player-recommend',
            name: 'AiHomePlayerRecommend',
            component: () => import('@/views/ai-home/player-recommend.vue'),
            meta: { title: '玩家推荐' },
        },
        {
            path: '/ai-home/profit-statistics',
            name: 'AiHomeProfitStatistics',
            component: () => import('@/views/ai-home/profit-statistics.vue'),
            meta: { title: '模拟收益统计' },
        },




        {
            path: '/model/:id',
            name: 'ModelDetail',
            component: () => import('@/views/model/modelById.vue'),
            meta: { title: '模型详情' },
        },
        {
            path: '/model/purchased',
            name: 'PurchasedModel',
            component: () => import('@/views/model/purchasedModel.vue'),
            meta: { title: '已购模型', requiresAuth: true },
        },
        {
            path: '/model/monitor',
            name: 'ModelMonitor',
            component: () => import('@/views/model/monitor/index.vue'),
            meta: { title: '模型监控' },
        },
        {
            path: '/model/monitor/:matchId',
            name: 'ModelMonitorDetail',
            component: () => import('@/views/model/monitor/index.vue'),
            meta: { title: '模型监控详情' },
        },

        // ==================== 战术板 ====================
        {
            path: '/tactical-board',
            name: 'TacticalBoard',
            component: () => import('@/views/tactical-board/index.vue'),
            meta: { title: '战术板' },
        },
        {
            // 竞彩足球
            path: '/tactical-board/jz',
            name: 'TacticalBoardJz',
            component: () => import('@/views/tactical-board/jz.vue'),
            meta: { title: '竞彩足球' },
        },
        {
            // 任选九场
            path: '/tactical-board/r9',
            name: 'TacticalBoardR9',
            component: () => import('@/views/tactical-board/r9.vue'),
            meta: { title: '任选九场' },
        },
        {
            // 14场胜负彩
            path: '/tactical-board/14c',
            name: 'TacticalBoard14c',
            component: () => import('@/views/tactical-board/14c.vue'),
            meta: { title: '14场胜负彩' },
        },
        {
            // 历史方案
            path: '/tactical-board/history',
            name: 'TacticalBoardHistory',
            component: () => import('@/views/tactical-board/history.vue'),
            meta: { title: '历史方案' },
        },
        {
            // 方案详情（创建成功后跳转）
            path: '/tactical-board/:planId',
            name: 'TacticalBoardDetail',
            component: () => import('@/views/tactical-board/tacticalBoardDetail.vue'),
            meta: { title: '方案详情' },
        },

        // ==================== 活动专区 ====================
        {
            path: '/activity',
            name: 'Activity',
            component: () => import('@/views/activity/index.vue'),
            meta: { title: '注册活动' },
        },
        {
            path: '/activity/worldcup',
            name: 'WorldCup',
            component: () => import('@/views/activity/worldcup.vue'),
            meta: { title: '世界杯活动' },
        },
        {
            path: '/activity/worldcup/schedule',
            name: 'WorldCupSchedule',
            component: () => import('@/views/activity/worldcup-schedule.vue'),
            meta: { title: '世界杯赛程' },
        },
        // ==================== 实单专家 ====================
        {
            path: '/shidan',
            name: 'Shidan',
            component: () => import('@/views/shidan/index.vue'),
            meta: { title: '实单专家' },
        },
        {
            path: '/shidan/shop/:id',
            name: 'ShidanShop',
            component: () => import('@/views/shidan/shopDetail.vue'),
            meta: { title: '店铺主页' },
        },
        {
            path: '/shidan/purchased',
            name: 'ShidanPurchased',
            component: () => import('@/views/shidan/purchased.vue'),
            meta: { title: '已购实单', requiresAuth: true },
        },
        {
            path: '/shidan/apply',
            name: 'ShidanApply',
            component: () => import('@/views/shidan/apply.vue'),
            meta: { title: '店主申请', requiresAuth: true },
        },
        {
            path: '/shidan/apply-status',
            name: 'ShidanApplyStatus',
            component: () => import('@/views/shidan/apply-status.vue'),
            meta: { title: '申请状态', requiresAuth: true },
        },
        {
            path: '/shidan/owner',
            name: 'ShidanOwner',
            component: () => import('@/views/shidan/owner.vue'),
            meta: { title: '店主管理', requiresAuth: true },
        },
        {
            path: '/shidan/edit',
            name: 'ShidanEdit',
            component: () => import('@/views/shidan/edit.vue'),
            meta: { title: '编辑资料', requiresAuth: true },
        },
        {
            path: '/shidan/bank',
            name: 'ShidanBank',
            component: () => import('@/views/shidan/bank.vue'),
            meta: { title: '银行卡配置', requiresAuth: true },
        },
        {
            path: '/shidan/publish',
            name: 'ShidanPublish',
            component: () => import('@/views/shidan/publish.vue'),
            meta: { title: '发布实单', requiresAuth: true },
        },
        {
            path: '/shidan/manage',
            name: 'ShidanManage',
            component: () => import('@/views/shidan/manage.vue'),
            meta: { title: '实单管理', requiresAuth: true },
        },
        {
            path: '/shidan/edit-post',
            name: 'ShidanEditPost',
            component: () => import('@/views/shidan/edit-post.vue'),
            meta: { title: '修改实单', requiresAuth: true },
        },
        // ==================== App 下载落地页（无需登录，供推广扫码使用）====================
        {
            path: '/download',
            name: 'Download',
            component: () => import('@/views/download/index.vue'),
            meta: { title: '下载有鱼体育' },
        },
        // ==================== 有鱼助手下载落地页（独立 AppKey l6mcf0xh，与上方完全隔离）====================
        {
            path: '/download-assistant',
            name: 'DownloadAssistant',
            component: () => import('@/views/download-assistant/index.vue'),
            meta: { title: '下载有鱼助手' },
        },

        // ==================== 销售推广 ====================
        {
            path: '/sales-promotion',
            name: 'SalesPromotion',
            component: () => import('@/views/sales-promotion/index.vue'),
            meta: { title: '销售推广', requiresAuth: true },
        },

        // ==================== 404 ====================
        {
            path: '/:pathMatch(.*)*',
            name: 'NotFound',
            component: () => import('@/views/error/404.vue'),
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) return savedPosition
        return { top: 0 }
    },
})

// ==================== 路由守卫（替代 Nuxt middleware）====================
const loginPaths = ['/login', '/emailLogin', '/logout', '/protocol']

/**
 * 从当前 URL 参数中同步登录信息到 Cookie
 * 用于宿主通过 iframe src 或 WebView URL 传递 token/uid 的场景
 */
const syncTokenFromUrlParams = (query: Record<string, any>) => {
    const token = query.token as string
    const uid = query.uid as string

    if (token) {
        Cookies.set('token', token, { expires: 7 })
        try { sessionStorage.setItem('token', token) } catch (e) { }
        console.log('[Router] 从 URL 参数同步 token 到 Cookie & Session')
    }
    if (uid) {
        Cookies.set('uid', uid, { expires: 7 })
        try { sessionStorage.setItem('uid', uid) } catch (e) { }
        console.log('[Router] 从 URL 参数同步 uid 到 Cookie & Session')
    }
}

router.beforeEach((to, from, next) => {
    // 更新页面标题
    if (to.meta?.title) {
        document.title = `${to.meta.title} - ${import.meta.env.VITE_TITLE || ''}`

        // 在 iframe 中同步标题到宿主
        if (hostBridge.isInIframe()) {
            hostBridge.updateTitle(to.meta.title as string)
        }
    }

    // ==================== 同步 URL 中的登录参数 ====================
    syncTokenFromUrlParams(to.query)

    // ==================== 登录鉴权拦截 ====================
    if (to.meta?.requiresAuth) {
        const hostType = hostBridge.getHostType()
        const token = to.query.token || Cookies.get('token')

        if (!token) {
            // 未登录，根据宿主类型处理
            if (hostType === 'app') {
                // App 环境：路由守卫放行，由页面内 useAuthGuard() 异步处理
                // 因为 appBridge.getAppLogin() 是异步的，不适合在同步 guard 中调用
                console.log('[Router] App 环境 requiresAuth，交给页面 useAuthGuard 处理')
                next()
                return
            } else if (hostType === 'h5') {
                // H5 iframe：通知宿主需要登录
                console.log('[Router] H5 iframe 未登录，通知宿主')
                hostBridge.requestLogin(to.fullPath)
                // 仍然放行页面加载，页面组件会显示 loading 状态等待登录回调
                next()
                return
            } else {
                // 浏览器独立访问：保存目标路径
                console.log('[Router] 浏览器未登录，保存 redirectPath:', to.fullPath)
                sessionStorage.setItem('redirectPath', to.fullPath)
                // tool_project 本身没有登录页，放行并由页面 useAuthGuard 处理
                next()
                return
            }
        }
    }

    // 登录重定向：保存来源页面（替代 login-redirect.global.ts middleware）
    const isGoingToLogin = loginPaths.some(path => to.path === path || to.path.startsWith(path + '/'))
    const isFromNonLoginPage = !loginPaths.some(path => from.path === path || from.path.startsWith(path + '/'))

    if (isGoingToLogin && isFromNonLoginPage) {
        const fromPath = from.fullPath
        if (fromPath && fromPath !== '/') {
            sessionStorage.setItem('redirectPath', fromPath)
        }
    }

    next()
})

export default router
